import mm from 'moment';

/** UTC wall clock for pause copy, e.g. "May 19, 09:00" (no local timezone shift). */
function formatPauseDateDisplay(raw) {
  if (raw == null || raw === '') return '';
  const utc = mm.utc(raw);
  if (utc.isValid()) return utc.format('MMM D, HH:mm');
  const zoned = mm.parseZone(raw);
  if (zoned.isValid()) return zoned.format('MMM D, HH:mm');
  const naive = mm(raw);
  return naive.isValid() ? naive.format('MMM D, HH:mm') : '';
}

export function terminalSlugFromEntry(entry, fallbackKey) {
  const slug = entry?.slug;
  if (slug != null && String(slug).trim() !== '') {
    return String(slug).trim().toUpperCase();
  }
  if (fallbackKey != null && String(fallbackKey).trim() !== '') {
    return String(fallbackKey).trim().toUpperCase();
  }
  return '—';
}

/** Load-out datetime for pause messaging, e.g. "May 19, 09:00". */
export function formatPauseLoadOutWindow(entry) {
  if (!entry || typeof entry !== 'object') return '';

  const preformatted =
    entry.load_out_window ??
    entry.pause_window ??
    entry.awaiting_load_out ??
    entry.load_out_label;
  if (preformatted != null && String(preformatted).trim() !== '') {
    return String(preformatted).trim();
  }

  const raw =
    entry.load_out_appointment_start ??
    entry.load_out_appointment ??
    entry.appointment_start ??
    entry.appointment_at ??
    entry.timeout;

  return formatPauseDateDisplay(raw);
}

/** Full pause copy from API (sibling of `timeout` on terminal preference entry). */
export function getTerminalPauseApiMessage(entry) {
  if (!entry || typeof entry !== 'object') return '';
  const raw = entry.timeoutMsg ?? entry.timeout_msg;
  if (raw == null || String(raw).trim() === '') return '';
  return String(raw).trim();
}

export function buildTerminalPauseMessage(entry, fallbackKey) {
  const apiMessage = getTerminalPauseApiMessage(entry);
  if (apiMessage) return apiMessage;

  const slug = terminalSlugFromEntry(entry, fallbackKey);
  const window = formatPauseLoadOutWindow(entry) || '—';
  return `Awaiting load-out: ${window}. Container must gate out from ${slug} before an empty return can be booked.`;
}

export function parseTerminalTimeoutUtc(timeout) {
  if (timeout == null || timeout === '') return null;
  const m = mm.utc(timeout);
  return m.isValid() ? m : null;
}

/** Pause is active while UTC timeout is still in the future. */
export function isTerminalPauseActive(timeout) {
  const end = parseTerminalTimeoutUtc(timeout);
  if (!end) return false;
  return end.isAfter(mm.utc());
}

export function countActiveTerminalPauses(terminalPrefs) {
  return Object.values(terminalPrefs || {}).filter((entry) =>
    isTerminalPauseActive(
      entry && typeof entry === 'object' ? entry.timeout : null
    )
  ).length;
}

export function buildPauseTooltipTitle(entry, fallbackKey) {
  return buildTerminalPauseMessage(entry, fallbackKey);
}
